import React from "react";
import styles from "./index.module.css";
import { MDBIcon } from "mdbreact";
import { userContext } from "../../Context/user";
import { Images } from "../../Assets/Images";
import { db, storage } from "../../fire";

export class Profile extends React.Component {
  state = {
    updatingAvatar: false,
    file: null
  };

  updateAvatar = async () => {
    try {
      this.setState({ updatingAvatar: true });
      const { user } = this.context;
      const { file } = this.state;
      const userId = user.uid || user.id;

      if (!file) return;

      const avatarRef = storage.ref().child(`/avatar/${userId}`);

      await avatarRef.put(file);

      const url = await avatarRef.getDownloadURL();

      await db
        .collection("users")
        .doc(userId)
        .update({ avatar: url });

      window.location.reload();
    } catch (error) {
    } finally {
      this.setState({ updatingAvatar: false });
    }
  };

  render() {
    const { user } = this.context;
    const { updatingAvatar } = this.state;

    return (
      <section className={styles.container}>
        <header>
          <section className={styles["blue-box"]}>
            <h1 className={styles.username}>
              {user.primeiroNome || user.nome}
            </h1>
            <p className={styles.userrole}>{user.formacao || "-"}</p>
          </section>
          <section className={styles["statuses-container"]}>
            <img
              className={styles.avatar}
              src={user.avatar || Images.avatar}
              alt=""
            />
            <main>
              <div className={styles["status-box"]}>
                <h2>430</h2>
                <p>Pedidos de serviço</p>
              </div>
              <div className={styles["status-box"]}>
                <h2>3/10</h2>
                <p>Nível de Parceria</p>
              </div>
              <div className={styles["status-box"]}>
                <h2>R$ 18.897</h2>
                <p>Ganhos</p>
              </div>
            </main>
          </section>
        </header>
        <main>
          <section className={styles["details-container"]}>
            <div className="d-flex justify-content-between">
              <div>
                <h2>Currículo</h2>
                <p className={styles["curriculum"]}>
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Magni necessitatibus consequatur reprehenderit a labore
                  repellat, ratione maxime optio assumenda perspiciatis, ad, in
                  nesciunt dolores aliquid eos iusto cupiditate molestiae.
                  Autem!
                </p>
              </div>
              <img src={user.avatar || Images.avatar} alt="" />
            </div>
            <div className="d-flex justify-content-around mt-5">
              <div className={styles.box}>
                <h3>
                  <MDBIcon
                    far
                    icon="paper-plane"
                    className="indigo-text pr-2"
                  />
                  Contatos
                </h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. </p>
              </div>
              <div className={styles.box}>
                <h3>
                  <MDBIcon icon="pen-alt" className="green-text pr-2" />
                  Formação
                </h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. </p>
              </div>
              <div className={styles.box}>
                <h3>
                  <MDBIcon icon="user-alt" className="amber-text pr-2" />
                  Publicações
                </h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
              </div>
              <div className={styles.box}>
                <h3>
                  <MDBIcon icon="rocket" className="red-text pr-2" />
                  Aprovações
                </h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. </p>
              </div>
            </div>
          </section>
          <section className={styles["config-container"]}>
            <h3>Configurações</h3>
            <div className={styles.divider}></div>
            <p>Edite seus dados ou informações para a comunidade e alunos</p>
            <div className="d-flex justify-content-center mt-5">
              <button
                onClick={() => {
                  document.querySelector("#avatar-input").click();
                }}
                disabled={updatingAvatar}
                className={styles.box}
              >
                <MDBIcon
                  size="lg"
                  icon="tablet-alt"
                  className="blue-grey-text"
                />
                <p>{updatingAvatar ? "Atualizando" : "Editar foto"}</p>
              </button>
              <button className={styles.box}>
                <MDBIcon size="lg" icon="cogs" className="blue-grey-text" />
                <p>Alterar senha</p>
              </button>
              <button className={styles.box}>
                <MDBIcon
                  size="lg"
                  icon="pencil-ruler"
                  className="blue-grey-text"
                />
                <p>Editar currículo</p>
              </button>
              <button className={styles.box}>
                <MDBIcon size="lg" icon="recycle" className="blue-grey-text" />
                <p>Solicitar rescisão</p>
              </button>
            </div>
          </section>
        </main>
        <input
          className={styles["hidden-file-input"]}
          type="file"
          accept="image/*"
          id="avatar-input"
          onChange={e => {
            this.setState(
              {
                file: e.target.files[0]
              },
              this.updateAvatar
            );
          }}
        />
      </section>
    );
  }
}

Profile.contextType = userContext;
